import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Utysa } from '../entity/Utysa-angular';


@Injectable({
  providedIn: 'root'
})
export class UtysaServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'SA001=MainTable,SA002=ITEM';
    this.defaultItem = new Utysa();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      SA001: '主資料表', SA002: '序號', SA003: '使用者代號', SA005: '備註'
    };

    this.fieldNames = 'SA001,SA002,SA003,SA005';
    this.fieldLengths = { SA001: 50, SA002: 50, SA003: 20, SA005: 255 };
    this.columnDefs = [
      { field: "SA001", headerName: "主資料表", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SA002", headerName: "序號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SA003", headerName: "使用者代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "SA004", headerName: "保留", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "SA005", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'UTYSA';
    this.isSys = true;
    this.sqlSelect = `SELECT UTYSA.*  FROM ##UTYSA`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY SA001,SA002,SA003`;
    this.keyFields = ['SA001', 'SA002', 'SA003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['SA001', 'SA002', 'SA003'];
    this.seqField = 'SA002';
    this.seqFieldLength = 50;
  }
  override async validateItem(item: Utysa): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utysa): Promise<Utysa> {
    await super.newRecord(newItem);
    return newItem;
  }




}

